import { NOTIFICATION_SETTINGS_API } from 'modules/profile/notification-settings/hooks/use-notification-settings'
import { NotificationSettingsInterface } from 'modules/profile/notification-settings/types/notification-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const usePaymentNotificationSettings = () => {
  const { fetcher } = useFetch<RequestMethodsEnum.put, NotificationSettingsInterface>({
    method: RequestMethodsEnum.put,
  })
  return {
    updatePaymentNotification: (data: {
      disableCompanyCustomerPurchase: boolean | null
      disableIndividualCustomerPurchase: boolean | null
    }) => fetcher(NOTIFICATION_SETTINGS_API, data),
  }
}
